<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-11"
         v-for="status in statuses"
         :key="status.key"
         @click="guidanceStatuesFilter(status.key)">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-' + status.color">
          <div class="card-icon">
            <md-icon>{{ status.icon }}</md-icon>
          </div>
          <h4 class="title">{{ status.title }}</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout text-center text-primary">
            <h3>
              {{ status.count }}
            </h3>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-progress-bar md-mode="indeterminate" v-if="isLoading"/>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>leaderboard</md-icon>
          </div>
          <h4 class="title">Guidance Lists</h4>
        </md-card-header>
        <md-card-content>
          <div class="text-right">
            <!-- Station -->
            <select-input
                v-model="station_id"
                track-by="id"
                label=" "
                placeholder="Select Station"
                :options="stations"
                :allow-empty="true"
                class="filter-dropdown"
            />
            <!-- Vendor -->
            <select-input
                v-model="vendor_id"
                track-by="uuid"
                label=" "
                placeholder="Select Vendor"
                :options="vendors"
                :allow-empty="true"
                class="filter-dropdown"
            />

            <!-- Port -->
            <select-input
                v-model="port_id"
                track-by="id"
                label=" "
                placeholder="Select Port"
                :options="ports"
                :allow-empty="true"
                class="filter-dropdown"
            />

            <!-- Department -->
            <select-input
                v-model="department_id"
                track-by="id"
                label=" "
                placeholder="Select Department"
                :options="departments"
                :allow-empty="true"
                class="filter-dropdown"
            />

            <!-- Guidance Type -->
            <select-input
                v-model="guidance_type"
                track-by="id"
                label=" "
                placeholder="Select Guidance Type"
                :options="guidanceTypes"
                :allow-empty="true"
                class="filter-dropdown"
            />

            <md-button
                v-if="can('create-guidance')"
                @click="goToAdd"
                class="md-primary md-dense add-guidance-btn"
            >
              <md-icon>add</md-icon>
              Add New
            </md-button>
          </div>

          <md-table
              :value="table"
              :md-sort.sync="sortation.field"
              :md-sort-order.sync="sortation.order"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover">
            <md-table-toolbar class="guidance-toolbar">

              <!-- Per Page -->
              <md-field class="toolbar-field per-page-field">
                <label>Per Page</label>

                <md-select
                    v-model="pagination.perPage"
                    name="pages"
                >
                  <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <!-- Start Date -->
              <div class="toolbar-datepicker">
                <label>Start Date</label>

                <md-datepicker
                    v-model="start_date"
                    md-immediately
                />
              </div>

              <!-- End Date -->
              <div class="toolbar-datepicker"
                   :class="{ 'is-disabled': !start_date }">

                <label>End Date</label>

                <md-datepicker
                    v-model="end_date"
                    md-immediately
                    :md-disabled-dates="disableEndDates"
                    :disabled="!start_date"
                />
              </div>

              <!-- Search -->
              <md-field class="toolbar-field search-field">
                <label>Search</label>

                <md-input v-model="query"/>
              </md-field>

            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell @click="goToView(item.id)"
                             style="width: 25%"
                             md-label="Name" md-sort-by="name">
                {{ item.name }}<br/>
                <badge :type="guidanceBadge(item.status)">{{ item.status||'Unknown' }}</badge>
              </md-table-cell>
              <md-table-cell @click="goToView(item.id)"
                             md-label="Guidance Number" md-sort-by="guidance_number">
                {{ item.guidance_number }}
                <br/>
                <badge :type="guidanceTypeBadge(item.guidance_type)">{{ item.guidance_type }} ({{item.pay_code}})</badge>
              </md-table-cell>
              <md-table-cell @click="goToView(item.id)"
                             md-label="Start Date" md-sort-by="start_date">{{
                  item.date_range
                }}
              </md-table-cell>
              <!--              <md-table-cell md-label="End Date" md-sort-by="end_date">{{item.end_date}}</md-table-cell>-->
              <md-table-cell md-label="Department" md-sort-by="department.name">{{
                  item.department.name
                }}
              </md-table-cell>
<!--              <md-table-cell md-label="Created At" md-sort-by="created_at">-->
<!--                {{ item.created_at }}-->
<!--              </md-table-cell> -->
              <md-table-cell md-label="Vendor" md-sort-by="vendor">
                {{ item.vendor?item.vendor.name:'' }}
               {{item.guidance_type}}
              </md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button

                    v-if="item.guidance_type==='Per Work Done'"
                    class="md-icon-button md-raised md-round md-warning"
                    @click="goManageWorkItem(item.id)"
                    style="margin: 0.2rem"
                >
                  <md-icon>search</md-icon>
                </md-button>
                  <md-button

                      v-else
                      class="md-icon-button md-raised md-round md-info"
                      @click="goToView(item.id)"
                      style="margin: 0.2rem"
                  >
                  <md-icon>search</md-icon>
                </md-button>
                <md-button
                    v-if="item.status!=='Approved' && item.status!=='Accepted'"
                    class="md-icon-button md-raised md-round md-info"
                    @click="goToEdit(item.id)"
                    style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button v-if="!item.status"
                    class="md-icon-button md-raised md-round md-danger"
                    @click="destroy(item.id)"
                    style="margin: 0.2rem">
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
              <tr>
                <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                >
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">
                      {{ item }}
                    </div>
                  </div>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
          />
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import Swal from 'sweetalert2';
import SelectInput from '../../../components/Inputs/SelectInput';
import formMixin from '@/mixins/form-mixin';
import badgeMixin from '@/mixins/badge-mixin';
import Vuex from 'vuex';
import Badge from '@/components/Badge.vue';

export default {
    components: {
        Badge,
        pagination: Pagination, SelectInput
    },
    mixins: [formMixin, badgeMixin],

    data: () => ({
      guidance_type: '',
      restoringListState: false,
      guidanceTypes: [
        {
          id: 'Per Man Hour',
          name: 'Per Man Hour',
        },
        {
          id: 'Per Work Done',
          name: 'Per Work Done',
        }
      ],
        statuses: [],
        filteredStatus: null,
        table: [],
        footerTable: [
            'Category',
            'Name',
            'Gudance Number',
            'Start Date',
            'End Date',
            'Status',
            'Department',
            'Guidance Type',
            // 'Created At',
            'Vendor',
            'Actions'],

        query: null,
        start_date: null,
        end_date:null,
        port_id: null,
        vendor_id: null,
        ports: [],
        vendors: [],
        station_id: null,
        stations: [],
        department_id: null,
        departments: [],
        filters: {},

        sortation: {
            field: 'created_at',
            order: 'desc',
        },

        pagination: {
            perPage: 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50, 100, 200, 300, 400, 500, 1000],
        },

        total: 0,
        isLoading: false,
    }),

    computed: {
        ...Vuex.mapState({
            me: state => state.profile.me
        }),
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },

        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        station () {
            return this.station_id;
        },
        department () {
            return this.department_id;
        },
        port () {
            return this.port_id;
        },
      vendor () {
            return this.vendor_id;
        },
      endDateDisabled() {
        return !this.start_date;
      },
      requestFilters() {
        const filters = {};

        if (this.query) {
          filters.queryKey = this.query;
        }

        if (this.filteredStatus) {
          filters.status = this.filteredStatus;
        }

        if (this.station_id) {
          filters.station = this.station_id;
        }

        if (this.port_id) {
          filters.port = this.port_id;
        }

        if (this.department_id) {
          filters.department = this.department_id;
        }

        if (this.vendor_id) {
          filters.vendor = this.vendor_id;
        }

        if (this.guidance_type) {
          filters.guidance_type = this.guidance_type;
        }

        if (this.start_date) {
          filters.start_date =
              this.formatDate(this.start_date);
        }

        if (this.end_date) {
          filters.end_date =
              this.formatDate(this.end_date);
        }

        console.log(
            'guidance_type:',
            this.guidance_type
        );

        console.log(
            'filters:',
            filters
        );

        console.log(
            'filters JSON:',
            JSON.stringify(filters)
        );

        return filters;
      }
    },

    watch: {
      async guidance_type(value) {

        console.log(
            'Guidance type changed:',
            value
        );
        if (this.restoringListState) {
          return;
        }
        await this.getList();
      },
        me: {
            handler: function (val) {
                this.roles = val.roles.map(r => r.name);
                this.allPermissions = val.allPermissions.map(p => p.name);
            },
            deep: true
        },
        query: {
            handler: 'getListDebounced',
            immediate: true,
        },
        sortation: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
        pagination: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
      async vendor() {

        // this.port_id = null;
        // this.department_id = null;
        //
        // if (!this.vendor_id) {
        //
        //   this.ports = [];
        //   this.departments = [];
        //
        // } else {
        //
        //   await this.$store.dispatch(
        //       'vendors/get',
        //       this.vendor_id
        //   );
        //
        //   const vendor =
        //       this.$store.getters['vendors/vendor'];
        //
        // }
        if (this.restoringListState) {
          return;
        }
        await this.getList();
      },
      // async station() {
      //
      //   this.port_id = null;
      //   this.vendor_id = null;
      //   this.department_id = null;
      //
      //   if (!this.station_id) {
      //
      //     this.ports = [];
      //     this.vendors = [];
      //     this.departments = [];
      //
      //   } else {
      //
      //     await this.$store.dispatch(
      //         'stations/get',
      //         this.station_id
      //     );
      //
      //     const station =
      //         this.$store.getters['stations/station'];
      //
      //     this.ports = station.ports || [];
      //     this.vendors =
      //         (station.activeTariffs || [])
      //             .map(tariff => tariff.vendor)
      //             .filter(vendor => vendor);
      //
      //     console.log(this.vendors);
      //     console.log(station);
      //   }
      //   if (this.restoringListState) {
      //     return;
      //   }
      //   await this.getList();
      // },
      async station() {

        if (!this.restoringListState) {
          this.port_id = null;
          this.vendor_id = null;
          this.department_id = null;
        }

        if (!this.station_id) {

          this.ports = [];
          this.vendors = [];
          this.departments = [];

        } else {

          await this.$store.dispatch(
              'stations/get',
              this.station_id
          );

          const station =
              this.$store.getters['stations/station'];

          this.ports = station.ports || [];

          this.vendors =
              (station.activeTariffs || [])
                  .map(tariff => tariff.vendor)
                  .filter(vendor => vendor);
        }

        if (!this.restoringListState) {
          await this.getList();
        }
      },
      async port() {

        this.department_id = null;

        if (!this.port_id) {

          this.departments = [];

        } else {

          await this.$store.dispatch(
              'ports/get',
              this.port_id
          );

          const port =
              this.$store.getters['ports/port'];

          this.departments =
              port.departments || [];
        }
        if (this.restoringListState) {
          return;
        }

        await this.getList();
      },
      department() {
        if (this.restoringListState) {
          return;
        }
        this.getList();
      },
      start_date(value) {

        if (!value) {
          this.end_date = null;
        }

        if (
            this.end_date &&
            new Date(this.end_date) <
            new Date(value)
        ) {
          this.end_date = null;
        }
        if (this.restoringListState) {
          return;
        }
        this.getList();
      },

      end_date() {
        if (this.restoringListState) {
          return;
        }
        this.getList();
      }

    },
   async created () {

     this.restoringListState = true;

     await this.restoreListState();

     this.restoringListState = false;
     await this.initData();



    },

    methods: {
      saveListState() {

        this.$store.commit(
            'guidances/SET_LIST_STATE',
            {
              query: this.query,
              start_date: this.start_date,
              end_date: this.end_date,
              port_id: this.port_id,
              vendor_id: this.vendor_id,
              station_id: this.station_id,
              department_id: this.department_id,
              guidance_type: this.guidance_type,
              filteredStatus: this.filteredStatus,

              pagination: {
                ...this.pagination,
              },

              sortation: {
                ...this.sortation,
              },
            }
        );
      },
      async restoreListState() {

        const saved =
            this.$store.getters['guidances/listState'];

        if (!saved) {
          return false;
        }

        this.query = saved.query || null;
        this.start_date = saved.start_date || null;
        this.end_date = saved.end_date || null;
        this.guidance_type = saved.guidance_type || '';
        this.filteredStatus = saved.filteredStatus || null;

        // Restore station first
        this.station_id = saved.station_id || null;

        if (this.station_id) {

          await this.$store.dispatch(
              'stations/get',
              this.station_id
          );

          const station =
              this.$store.getters['stations/station'];

          this.ports = station.ports || [];

          this.vendors =
              (station.activeTariffs || [])
                  .map(tariff => tariff.vendor)
                  .filter(vendor => vendor);
        }

        // Now restore port
        this.port_id = saved.port_id || null;

        if (this.port_id) {

          await this.$store.dispatch(
              'ports/get',
              this.port_id
          );

          const port =
              this.$store.getters['ports/port'];

          this.departments =
              port.departments || [];
        }

        // Now dependent selections can safely be restored
        this.vendor_id = saved.vendor_id || null;
        this.department_id = saved.department_id || null;

        if (saved.pagination) {
          this.pagination = {
            ...this.pagination,
            ...saved.pagination,
          };
        }

        if (saved.sortation) {
          this.sortation = {
            ...this.sortation,
            ...saved.sortation,
          };
        }

        return true;
      },
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),

      async getList() {

        this.isLoading = true;

        try {

          const params = this.buildParams();

          await Promise.all([
            this.$store.dispatch('guidances/list', params),
            this.loadStatistics()
          ]);

          this.table =
              this.$store.getters['guidances/list'];

          this.total =
              this.$store.getters['guidances/listTotal'];

        } catch (e) {

          this.notifyException(e);

        } finally {

          this.isLoading = false;
        }
      },
      async loadStatistics() {

        const params =
            this.buildParams(false);

        await this.$store.dispatch(
            'guidances/statusStatistics',
            params
        );

        this.statuses =
            this.$store.getters[
                'guidances/statistics'
                ];
      },
      async initData() {

        await Promise.all([
          this.loadStatistics(),
          this.$store.dispatch('stations/list')
        ]);

        this.stations =
            this.$store.getters['stations/list'];

        await this.getList();
      },
      async getVendors(){
        await  this.$store.dispatch('vendors/list')
        this.vendors=this.$store.getters['vendors/list'];
      },
        async guidanceStatuesFilter (status) {
            this.filteredStatus = status;
            await this.getList();
        },

        async destroy (guidance) {
            const confirmation = await Swal.fire({
                title: 'Delete this Guidance?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
            });

            if (confirmation.value === true) {
                try {
                    await this.$store.dispatch('guidances/destroy', guidance);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Guidance deleted successfully.'
                    );
                    await this.getList();
                } catch (e) {
                    if (e.response.data.errors[0]) {
                        await this.$store.dispatch(
                            'alerts/error',
                            e.response.data.errors[0].title
                        );
                    } else {
                        await this.$store.dispatch(
                            'alerts/error',
                            'Oops, something went wrong!'
                        );
                    }
                }
            }
        },

        goToAdd () {
            this.$router.push({ name: 'Add Guidance' });
        },

        goToEdit (id) {
            this.$router.push({ name: 'Edit Guidance', params: { id } });
        },

        goToView (id) {
          this.saveListState();
            this.$router.push({ name: 'View Guidance', params: { id } });
        },
      goManageWorkItem (id) {
        this.saveListState();
        this.$router.push({name: 'Manage Guidance Work Item', params: {id: id}});
      },


        customSort () {
            return false;
        },
      disableEndDates(date) {

        if (!this.start_date) {
          return false;
        }

        return date < new Date(this.start_date);
      },

      formatDate(date) {

        if (!date) {
          return null;
        }

        const d = new Date(date);

        const year = d.getFullYear();

        const month = String(
            d.getMonth() + 1
        ).padStart(2, '0');

        const day = String(
            d.getDate()
        ).padStart(2, '0');

        return `${year}-${month}-${day}`;
      },
      buildParams(withPagination = true) {

        const params = {
          include: 'department',
          ...(this.sort ? { sort: this.sort } : {}),
          filter: this.requestFilters
        };

        if (withPagination) {
          params.page = {
            number: this.pagination.currentPage,
            size: this.pagination.perPage
          };
        }

        return params;
      },
    }
};
</script>
<style scoped>
.filter-dropdown {
  width: 100%;
}

/deep/ .multiselect {
  min-width: 180px;
  width: 100%;
}

@media (min-width: 768px) {
  /deep/ .multiselect {
    min-width: 250px;
  }
}

.guidance-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.toolbar-field {
  margin: 0 !important;
}

.per-page-field {
  width: 120px;
}

.date-field {
  width: 180px;
}

.search-field {
  width: 250px;
}

@media (max-width: 768px) {

  .guidance-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .per-page-field,
  .date-field,
  .search-field {
    width: 100%;
  }
}
.toolbar-datepicker {
  width: 180px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 8px;
}

.toolbar-datepicker label {
  font-size: 12px;
  color: rgba(0,0,0,.54);
  margin-bottom: 4px;
}
.add-guidance-btn {
  min-height: 28px !important;
  height: 28px !important;
  padding: 0 8px !important;
  font-size: 11px !important;
}

.add-guidance-btn .md-icon {
  font-size: 16px !important;
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin-right: 4px;
}
</style>
